var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBtnActionbarCateN32 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 18.5,
  height: 19.3,
  x: 6.5,
  y: 6.3,
  fill: "#D9D9D9",
  rx: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10.25 11.3h11v1.5h-11zM10.25 15.3h11v1.5h-11zM10.25 19.3h11v1.5h-11z"
})));
export default SvgBtnActionbarCateN32;